module.exports = __webpack_public_path__ + "31ec3a3de1dcba303478a86804001a6e.png";